// ------------------------------------
// props 輸入需求 :
// props.page_active : array                            ( nav bar 變顏色用(5個分頁，5個index) --> [true, false, false, false, false] )
// ------------------------------------

import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import common_images from '../../comm_imgs'
import { resources } from '../../i18n'
import DropdownLNG from './DropdownLNG'
import LogoutBtn from '../Login/LogoutBtn'
import './_navBar.scss'
import NotificationBar from './NotifictionBar'
import dh_alert from '../../actions/dataHandler_alert';
import { useDispatch, useSelector } from 'react-redux'
import dataHandler_alert from '../../actions/dataHandler_alert'
import ApiGo from '../../actions/ApiGo'
import { ADD_ALERTS_ARRAY, ADD_ALERTS_ARRAY_RESIDENT } from '../../stores/reducer_alerts'
import { LogTime } from '../../actions/forFrontEnd_Log'
import AlertCancel from '../popUp/AlertCancel'
import ConfigHandler from '../../actions/ConfigHandler'
import { ADD_RESPONSE, ADD_RESPONSE_JSON } from '../../stores/reducer_add'
import { SET_ADDPAGE, SET_LAYOUTPAGE } from '../../stores/reducer_LayoutPage'
import Account from '../../actions/Account'

const NavBar = (props) => {
    const ACCOUNT_NAME = () => localStorage.getItem("currentUser") || sessionStorage.getItem("currentUser")

    // 登出組合
    const [logoutBtn, setLogoutBtn] = useState(false);
    function toggleLogoutBtn() { setLogoutBtn(!logoutBtn) }

    // ------ 從 redux 拿 resident row ------------------
    const store_resident_array = useSelector(state => state.store_residents.orign_residents_array);
    const store_beds_array = useSelector(state => state.store_beds.beds_array)
    const LayoutPage = useSelector(state => state.store_layout)
    // ------ 從 redux 拿 resident row ------------------

    // i18n 組合
    const { t, i18n } = useTranslation(); // 1.2 i18n
    const tRef = useRef(t);
    useEffect(() => { tRef.current = t; }, [t]);
    const voiceTestRef = useRef("");
    useEffect(() => {
        voiceTestRef.current = t("ADMIN.SPEAK_TEST.VOICE_TEST");
    }, [t]);
    const isVital = ConfigHandler.isVital;
    const lng_choice = Object.entries(resources).map(res => res[1].title)
    lng_choice.unshift(t('GLOBAL.CHANGE_LANGUAGE'))
    const DP_data = { keys: lng_choice }
    const [returnLng, setReturnLng] = useState("");     //dropdown return result
    // language 存為預設
    function storeLanguageToStorage(lng) {
        localStorage.setItem("i18nextLng", lng)
        sessionStorage.setItem("i18nextLng", lng)
    }
    // language 修改
    useEffect(() => {
        let result = Object.entries(resources).filter(res => res[1].title === returnLng)[0]
        if (result !== undefined) {
            storeLanguageToStorage(result[0])
            i18n.changeLanguage(result[0])
        }
    }, [returnLng, i18n])
    // 換語言按鈕 新版 (非dropdown)
    const [lngBtn, setLngBtn] = useState(false);
    function toggleLngBtn() { setLngBtn(!lngBtn) }

    // ----------- Notify 組合 --------------------------
    const [notify, setNotify] = useState(false);
    function toggleNotify() { setNotify(!notify) }
    const [notificationAmount, setNotificationAmount] = useState(0);
    const mos = props.mos
    const mos_events = mos.events;
    const mos_diaper = mos.diaper;
    // const [mos_moteckAR, setMos_moteckAR] = useState(false);
    const mos_moteckAR = mos.moteckAlertReply;
    const mos_rr = (ConfigHandler.isShowCF()) ? mos.CFBreath : mos.rr;
    const mos_hr = (ConfigHandler.isShowCF()) ? mos.CFHeartBeat : 2;
    const [alertSpeakCount, setAlertSpeakCount] = useState(1);
    const store_alerts = useSelector(state => state.store_alerts.alert_array)
    const dispatch = useDispatch()
    async function getAlert() {
        let [alert, vital, diaper, resident_arr, unResolved] = [{}, [], [], [], []]
        if (isVital) {
            try {
                vital = await ApiGo.getAll_resident_vital_abnormal(new LogTime().getDate(), "ALL");
                let _temp = vital.filter(res => {
                    if (res.resolved !== null) return false
                    if (ConfigHandler.isFdaClass === 2) return false  // FDA class 2 時排除呼吸告警
                    return true
                });
                unResolved = [..._temp, ...unResolved];
            } catch (error) {
                console.error("Error fetching vital abnormal data:", error);
            }
        }
        try {
            alert = await ApiGo.getAll_resident_bed_state_alerts(new LogTime().getDate(), "ALL")
            let _temp = alert.alerts.filter(res => res.resolved === null)
            unResolved = [..._temp, ...unResolved]
        }
        catch { }

        dispatch(ADD_ALERTS_ARRAY(unResolved))
        unResolved.forEach(res => {
            let resident = store_resident_array.filter(store => store.id === res.resident_id)[0]
            if (resident === null || resident === undefined) { return }
            if (resident_arr.indexOf(resident.id) === -1) { resident_arr.push(resident.id) }
        })
        dispatch(ADD_ALERTS_ARRAY_RESIDENT(resident_arr))
    }

    useEffect(() => {
        ApiGo.getAlert_speak_count()
            .then(res => {
                let _time = res.split(" ")[1]
                let _speed = res.split(" ")[3]

                setAlertSpeakCount({
                    timeCount: parseInt(_time[0]),
                    speed: parseInt(_speed)
                })
            })
            .catch(() => { })
        if (store_resident_array.length === 0) { return }
        getAlert()
    }, [store_resident_array])

    // ---------- 臨時性 for 有線版 --------------------------------------------------------
    useEffect(() => {
        if (!ConfigHandler.isShowAIDC()) { return }
        if (mos_moteckAR === false) { return }

        if (mos_moteckAR === "init serial failed!") {
            let _txt = '發生USB脫落或插拔問題'
            speak(_txt);
            dispatch(ADD_RESPONSE({ status: 422, statusText: "", type: "alert_reply_usb" }))
            dispatch(ADD_RESPONSE_JSON({ detail: [{ loc: ["body", "* 請至admin頁面"] }, { loc: ["body", "* 重啟uart_test系統"] }] }))
        }
        if (mos_moteckAR === "請壓床右側才能完成系統設定!") {
            let _txt = '請壓床右側才能完成系統設定'
            speak(_txt);
            dispatch(ADD_RESPONSE({ status: 422, statusText: "", type: "alert_reply_Unpress" }))
            dispatch(ADD_RESPONSE_JSON({ detail: [{ loc: ["body", "* 請壓床墊右側"] }, { loc: ["body", "* 以完成系統設定"] }] }))
        }
    }, [mos_moteckAR]);
    // ---------- 臨時性 for 有線版 --------------------------------------------------------

    // 語音測試，以防瀏覽器擋住語音播放，所以模仿點擊
    useEffect(() => {
        const handleUserGesture = () => {
            const text = voiceTestRef.current;
            const utterance = new SpeechSynthesisUtterance(text);
            utterance.lang = i18n.language;
            speechSynthesis.cancel();
            speechSynthesis.speak(utterance);
            window.removeEventListener('click', handleUserGesture);
        };
        window.addEventListener('click', handleUserGesture);
        return () => {
            window.removeEventListener('click', handleUserGesture);
        };
    }, []);

    useEffect(() => {
        let _txt = ''
        if (mos_events === null) { return }
        if (dh_alert(mos_events.alert_level, mos_events.bed_state) === "No such information") { return }
        let _bed_info = store_beds_array.filter(bed => bed.id === mos_events.bed_id)[0] || [];
        let _resident = store_resident_array.filter(resid => resid.id === _bed_info.resident_id)[0] || null;
        if (_resident === null) { return }
        if (dh_alert(mos_events.alert_level, mos_events.bed_state).level === "emergency") {
            // 離床告警語音
            _txt = _resident.first_name + _resident.last_name + t(dataHandler_alert(mos_events.alert_level, mos_events.bed_state).msg)
            speak(_txt);
            if ("Notification" in window) {
                // 請求使用者授權顯示通知
                Notification.requestPermission().then(function (permission) {
                    if (permission === "granted") {
                        // 發送桌面通知
                        new Notification("離床告警", {
                            body: _txt,
                            icon: dataHandler_alert(mos_events.alert_level, mos_events.bed_state).img,
                            lang: i18n.language,
                            dir: 'ltr',
                            requireInteraction: true
                        });
                    }
                });
            }
        }
        getAlert()
    }, [mos_events]);


    useEffect(() => {
        if (ConfigHandler.isFdaClass === 2) { return }
        if (mos_rr !== null) {
            handlingAlertFilter()
        }
        function handlingAlertFilter() {
            if (mos_rr === null) { return }
            if (mos_rr.value === "-") { return }

            let _bed_info = store_beds_array.filter(bed => bed.mac === mos_rr.mac)[0] || [];
            let _resident = store_resident_array.filter(resid => resid.id === _bed_info.resident_id)[0] || null;
            if (_resident === null) { return }
            if (mos_rr.value <= _resident.breath_high && mos_rr.value >= _resident.breath_low) { return }
            let status = ""
            if (mos_rr.value > _resident.breath_high) { status = "呼吸過快" }
            if (mos_rr.value < _resident.breath_low) { status = "呼吸過慢" }
            let _txt = _resident.first_name + _resident.last_name + status
            speak(_txt);
            if ("Notification" in window) {
                // 請求使用者授權顯示通知
                Notification.requestPermission().then(function (permission) {
                    if (permission === "granted") {
                        // 發送桌面通知
                        new Notification("呼吸告警", {
                            body: _txt,
                            icon: common_images.BREATH_LOW,
                            lang: i18n.language,
                            dir: 'ltr',
                            requireInteraction: true
                        });
                    }
                });
            }
        }
        getAlert()
    }, [mos_rr]);

    useEffect(() => {
        let _div = store_alerts.map((res, index) => {
            if (ConfigHandler.isFdaClass === 2) return
            let resident = store_resident_array.filter(store => store.id === res.resident_id)[0]
            if (resident === undefined) return
            else return res
        })
        let _res = _div.filter(div => div !== undefined)
        setNotificationAmount(_res.length)
    }, [store_alerts, store_resident_array])

    function speak(msg) {
        const { timeCount = 1, speed = 1 } = alertSpeakCount;
        let count = 0;
        function sayOnce() {
            if (count >= timeCount) return;
            const u = new SpeechSynthesisUtterance(msg);
            u.lang = i18n.language;
            u.rate = speed;
            u.onend = () => {
                count++;
                sayOnce();
            };
            speechSynthesis.speak(u);
        }
        sayOnce();
    }
    // ----------- Notify 組合 --------------------------
    let _nav_div = ConfigHandler.layoutControl().layoutArr.map((res, index) => <div key={res[1]} className={`fx-d-c fx-ccc nav-option ${(LayoutPage.pageActive[index]) ? 'activate' : ''} ${res[2] ? '' : 'd-none'}`}
        onClick={() => {
            dispatch(SET_LAYOUTPAGE(index))
            dispatch(SET_ADDPAGE(index))
        }}>
        <img src={res[0]} className="pic" alt={res[1]} />
        <div id="Dashboard">{t(res[1])}</div>
    </div>)

    const [alertCancel, setAlertCancel] = useState({
        cancel: false,
        resident: 0
    });
    function toggleAlertCancel(res) {
        setAlertCancel({
            cancel: !alertCancel.cancel,
            resident: res
        })
        setNotify(false)
    }

    const store_resident_withAlerts = useSelector(state => state.store_alerts.residents_with_alerts)
    function identifyAlert(store = [], id = "", cancel, alerts) {
        let _index = store.indexOf(id)
        if (!cancel) { return { open: false, content: {} } }
        if (_index === -1) { return { open: false, content: {} } }
        let _a = alerts.filter(res => res.resident_id === id)
        return { open: true, content: _a }
    }


    return (
        <div className="container-fluid">
            {identifyAlert(store_resident_withAlerts, alertCancel.resident.id, alertCancel.cancel, store_alerts).open ?
                <AlertCancel
                    hide={toggleAlertCancel}
                    content={identifyAlert(store_resident_withAlerts, alertCancel.resident.id, alertCancel.cancel, store_alerts).content}
                    resident={alertCancel.resident}
                />
                : null}

            <div className="row navBar">
                <div className="col fx-fsn notification" >
                    <div className="pad-15 t row fx-fsc">
                        <div className={`font-xxl cursor-pointer ${ConfigHandler.isShowEP() ? "opac0" : ""}`} onClick={toggleNotify}>{ConfigHandler.isShowEP() ? "M" : t("GLOBAL.TITLE_NAME")}</div>
                        <div className={`mar-15 cursor-pointer notf_hover l ${notify ? "w-60" : "w-35"}`} onClick={toggleNotify}>
                            <div className="font-l fx-d-r w-100 notf_text">
                                {t("GLOBAL.NOTIFICATION")}
                                <div className="notf_count fx-ccc br-10 mar-5 b">{notificationAmount}</div>
                            </div>
                            <div className="notf_bar w-100" ></div>
                            <div onClick={e => e.stopPropagation()}>
                                {notify ? <NotificationBar toggleAlertCancel={toggleAlertCancel} closeTab={toggleNotify} /> : null}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-4 font-ml">{_nav_div}</div>
                <div className="col fx-d-r fx-fec font-ml cancel-pad">
                    <div className="fx-d-c pad-15 l " onClick={toggleLngBtn}>
                        <div className={`fx-d-c fx-ccc nav-option ${(lngBtn) ? "activate" : ""}`}>
                            <img src={common_images.LANG} className="pic" alt="i18n" />
                            <div>{t("GLOBAL.CHANGE_LANGUAGE")}</div>
                        </div>
                        <div>
                            {lngBtn ? <DropdownLNG
                                hide={toggleLngBtn}
                                data={DP_data}
                                setReturnLng={setReturnLng}
                            /> : null}
                        </div>
                    </div>
                    {
                        Account.isAutoLoginViaUrl()
                            ? <div className="fx-d-c pad-15 l">
                                <div className="fx-d-c fx-ccc nav-option no-hover">
                                    <img src={common_images.USER} className="pic" alt="logout" />
                                    <div>{ACCOUNT_NAME()}</div>
                                </div>
                            </div>
                            : <div className="fx-d-c pad-15 l " onClick={toggleLogoutBtn}>
                                <div className={`fx-d-c fx-ccc nav-option ${(logoutBtn) ? "activate" : ""}`}>
                                    <img src={common_images.USER} className="pic" alt="logout" />
                                    <div>{ACCOUNT_NAME()}</div>
                                </div>
                                <div>
                                    {logoutBtn ? <LogoutBtn hide={toggleLogoutBtn} /> : null}
                                </div>
                            </div>

                    }
                </div>
            </div>
        </div >
    );
}
export default NavBar;
